import Usuario from "model/administracao/cadastro/Usuario";
import DocumentoVersao from "./DocumentoVersao";
import GrupoUsuarios from "model/administracao/cadastro/GrupoUsuarios";

export default class DocumentoVersaoNecessidadeConfirmacao {
    id: number;
    documentoVersao: DocumentoVersao | null;
    usuario: Usuario | null; 
    grupo: GrupoUsuarios | null;

    constructor() {
        this.id = 0;
        this.documentoVersao = null;
        this.usuario = null;
        this.grupo = null;
    }
}